<div class="d-flex flex-column" formGroupName="address">
  <p class="fw-bold">
    {{ 'user_edit_overview_l' | translate }}: {{ 'user_address_edit.form_l' | translate }}
  </p>

  <div class="mb-3 d-flex flex-row gap-3">
    <im-form-field class="flex-grow-1">
      <label class="im:floating-label">
        <span floatingLabel>{{ 'user_address_edit_street_l' | translate }}</span>
        <input
          class="im:input"
          type="text"
          formControlName="street"
          [placeholder]="'user_address_edit_street_l' | translate"
        />
      </label>
    </im-form-field>

    <im-form-field>
      <label class="im:floating-label">
        <span floatingLabel>{{ 'user_address_edit_house_number_l' | translate }}</span>
        <input
          class="im:input"
          type="text"
          formControlName="houseNumber"
          [placeholder]="'user_address_edit_house_number_l' | translate"
        />
      </label>
    </im-form-field>
  </div>

  <div class="mb-3 d-flex flex-row gap-3">
    <im-form-field>
      <label class="im:floating-label">
        <span floatingLabel>{{ 'user_address_edit_postcode_l' | translate }}</span>
        <input
          class="im:input"
          type="text"
          minlength="4"
          maxlength="5"
          formControlName="zipCode"
          [placeholder]="'user_address_edit_postcode_l' | translate"
        />
      </label>
    </im-form-field>

    <im-form-field class="flex-grow-1">
      <label class="im:floating-label">
        <span floatingLabel>{{ 'user_address_edit_city_l' | translate }}</span>
        <input
          class="im:input"
          type="text"
          formControlName="city"
          [placeholder]="'user_address_edit_city_l' | translate"
        />
      </label>
    </im-form-field>
  </div>
</div>
